import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

export const FAQ = () => {
  const faqs = [
    {
      question: 'Brauche ich Trainingserfahrung?',
      answer: 'Nein, das Programm ist für alle Level geeignet. Wir starten mit einer individuellen Analyse und passen die Übungen an dein aktuelles Niveau an. Ob Anfänger oder Fortgeschrittener – du wirst genau dort abgeholt, wo du stehst.'
    },
    {
      question: 'Was, wenn ich wenig Zeit habe?',
      answer: 'Das Programm benötigt nur 3× 30 Minuten pro Woche. Du kannst die Einheiten flexibel in deinen Alltag integrieren – zu Hause, im Büro oder unterwegs. Kein Fitnessstudio, keine Anfahrtszeiten.'
    },
    {
      question: 'Kann ich mit Schmerzen trainieren?',
      answer: 'Ja, das Programm ist speziell für Menschen mit Rücken- und Haltungsproblemen entwickelt. Wir arbeiten gezielt an den Ursachen deiner Schmerzen, nicht gegen sie. Jede Übung wird so angepasst, dass sie sicher und schmerzfrei durchführbar ist.'
    },
    {
      question: 'Ist das Programm für Anfänger geeignet?',
      answer: 'Absolut! Gerade Anfänger profitieren enorm, weil sie von Anfang an die richtigen Bewegungsmuster lernen. Du bekommst klare Anleitungen, Video-Demonstrationen und im Pro/Premium-Paket sogar persönliches Feedback.'
    },
    {
      question: 'Welche Ausrüstung brauche ich?',
      answer: 'Du brauchst nur minimale Ausrüstung: Trainingsbänder, eine Kettlebell und eine Trainingsmatte. Alles zusammen kostet unter 50€ und kann jahrelang genutzt werden. Keine teuren Geräte oder Gym-Mitgliedschaft notwendig.'
    },
    {
      question: 'Wie unterscheiden sich die Tarife?',
      answer: 'Basic gibt dir Zugang zu allen Videos und Plänen. Pro enthält zusätzlich Videoanalyse und Chat-Support. Premium bietet persönliche Beratung und maßgeschneiderte Anpassungen. Wähle basierend darauf, wie viel individuelle Betreuung du möchtest.'
    },
    {
      question: 'Kann ich jederzeit kündigen?',
      answer: 'Ja, alle Tarife sind monatlich kündbar. Keine langfristigen Verpflichtungen. Du entscheidest jeden Monat neu, ob du weitermachen möchtest.'
    }
  ];

  return (
    <section style={{
      padding: 'var(--spacing-giant) 0',
      background: 'var(--bg-subtle)'
    }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="display-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Häufig gestellte Fragen
          </h2>
          <p className="body-large" style={{ maxWidth: '700px', margin: '0 auto' }}>
            Hier findest du Antworten auf die wichtigsten Fragen zum Programm.
          </p>
        </div>

        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} style={{
                background: 'var(--bg-card)',
                marginBottom: 'var(--spacing-small)',
                borderRadius: '24px',
                border: 'none',
                overflow: 'hidden'
              }}>
                <AccordionTrigger style={{
                  padding: 'var(--spacing-medium) var(--spacing-large)',
                  fontSize: 'clamp(1.125rem, 2vw, 1.25rem)',
                  fontWeight: 600,
                  color: 'var(--text-primary)',
                  textAlign: 'left'
                }}>
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent style={{
                  padding: '0 var(--spacing-large) var(--spacing-medium)',
                  fontSize: 'clamp(1rem, 2vw, 1.125rem)',
                  color: 'var(--text-secondary)',
                  lineHeight: 1.6
                }}>
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};